import 'rxjs/add/operator/debounceTime';
import {Component, ElementRef, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {DateTime, Header, NavController, NavParams, ViewController} from 'ionic-angular';

import {CONFIG} from '../../../app/config';
import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";
import {
    TAction,
    TGeradorView,
    TFinanceSide,
    TFinanceView,
    TFinanceDate,
    TPaymentStep,
    TConsumoCalc,
} from "../../../app/enum";

import {LogadoService} from '../../../providers/logado-service';
import {ProfileService} from "../../../providers/profile-service";
import {HotspotService} from "../../../providers/hotspot-service";
import {StorageService} from "../../../providers/storage-service";
import {RepasseMenuPage} from "../repasse-menu/repasse-menu";
import {GateweyMenuPage} from '../gatewey-menu/gatewey-menu';

@Component({
    selector: 'page-finance-menu',
    templateUrl: 'finance-menu.html',
    providers: [HotspotService, ProfileService]
})
export class FinanceMenuPage {

    @ViewChildren(DateTime) iondates: QueryList<DateTime>;

    @ViewChild(Header) header: Header;
    @ViewChild('pulsedItem') pulsedElement: ElementRef;

    TGeradorView: any = TGeradorView;
    TFinanceSide: any = TFinanceSide;
    TFinanceView: any = TFinanceView;
    TConsumoCalc: any = TConsumoCalc;
    TPaymentStep: any = TPaymentStep;

    pulsed: boolean;

    config: any;
    logado: any;
    perfil: any;
    userset: any;

    etapa: number;

    rootcash: any;

    rootspot: any;
    copyspot: any;

    filtred: any;

    financeSide: TFinanceSide;
    backupeDate: TFinanceDate;

    cashday: string;
    financeView: TFinanceView;
    financeDate: TFinanceDate;
    contratoView: TGeradorView;
    consumoCalc: TConsumoCalc;

    indexGR: number;
    indexLN: number;

    constructor(public navCtrl: NavController, public viewCtrl: ViewController, public navParams: NavParams,
                public util: Util, public hotspotService: HotspotService, public storageService: StorageService,
                public logadoService: LogadoService, public profileService: ProfileService) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();
        this.perfil = this.navParams.get('perfil');
        this.userset = this.navParams.get('userset');

        this.etapa = this.navParams.get('etapa');

        this.indexGR = this.navParams.get('indexGR');
        this.indexLN = this.navParams.get('indexLN');

        this.financeSide = this.navParams.get('financeSide');
        this.financeView = this.navParams.get('financeView');
        this.financeDate = this.navParams.get('financeDate');
        this.contratoView = this.navParams.get('contratoView');
        this.consumoCalc = this.navParams.get('consumoCalc');
        this.cashday = this.navParams.get('cashday');

        this.rootspot = this.navParams.get('rootspot');
        this.copyspot = this.navParams.get('copyspot');
        this.rootcash = this.navParams.get('rootcash');
        this.filtred = this.navParams.get('filtred');

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Finance Menu', '/finance-menu');

        if (this.etapa <= 4) this.financeLoad();

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleLightContent);

    }

    getTitle() {

        let consumo = (this.financeSide == TFinanceSide.cdDebito ? 'Despesa' : 'Receita');
        let finance = (this.financeSide == TFinanceSide.cdDebito ? 'Enviado' : (this.financeSide == TFinanceSide.cdCredito ? 'Recebido' : 'Resultado'));

        if (this.etapa == 0) return 'Público';
        if (this.etapa == 1) return consumo;
        if (this.etapa == 2) return finance;
        if (this.etapa == 3) return 'Contrato';
        if (this.etapa == 4) return 'Extrato';
        if (this.etapa == 9) return this.rootcash.Finances[this.indexGR].FinanceLines[this.indexLN].FinanceText;
        if (this.etapa == 10) return 'Como Funciona?';

    }

    /** ************************************************ WEBSTOR ************************************************** **/
    /** ************************************************ etapa-0 ************************************************** **/

    financeLoad() {

        let hotspotID = this.rootspot.Hotspots[0].HotspotID;
        let filtredID = (this.etapa == 4 ? this.filtred.AccountID : (!this.filtred ? 0 : this.filtred.FinanceFlag));

        let onLoad = (data) => {

            this.rootcash = data;
            this.storageService.set('FINANCE-DATE', this.financeDate).subscribe();
            this.storageService.set('FINANCE-DATA', this.cashday).subscribe();

        };

        onLoad(null);
        let action = TAction.acHome;
        if (this.etapa == 0) action = TAction.acUser;
        if (this.etapa == 1) action = TAction.acSale;
        if (this.etapa == 2) action = TAction.acCash;
        if (this.etapa == 3) action = TAction.acGera;
        if (this.etapa == 4) action = TAction.acBank;
        if (this.etapa == 9) action = TAction.acInfo;

        //Corrige Lastday Exemplo: vem 2021-02-31 troca para 2021-02-28
        this.cashday = this.util.dateLast(this.cashday);

        let params = '&FiltredID=' + filtredID + '&ProfileID=' + this.perfil.Profile.ProfileID + '&PaybookSide=' + this.financeSide + '&Cashday=' + this.cashday + '&FinanceDate=' + this.financeDate + '&ConsumoCalc=' + this.consumoCalc + '&ContratoView=' + this.contratoView;

        let request = null;
        request = this.hotspotService.finance(action, 0, hotspotID, filtredID, this.perfil.Profile.ProfileID, this.financeSide, this.cashday, this.financeDate, this.consumoCalc, this.contratoView)
      //request = this.util.monitorDesk(false, 'DESK-FINANCE', hotspotID, params, action)

        request
            .subscribe(
                data => onLoad(data),
                erro => this.util.alertResult(erro, () => this.dismiss())
            );

    }

    financeInfo() {

        let object = {etapa: 10, perfil: this.perfil, userset: this.userset, copyspot: this.copyspot, rootspot: this.rootspot, rootcash: this.rootcash, financeSide: this.financeSide, cashday: this.cashday, financeDate: this.financeDate, financeView: this.financeView, indexGR: 0, indexLN: 0};
        this.util.modalopen(FinanceMenuPage, 'full', true, object).subscribe();

    }

    hotviewPush(finance, payline) {

        if (this.etapa == 2 && finance.FinanceNome == 'Período') {
            let array = this.cashday.split('-');
            let zeros = ("0" + payline.FinanceFlag).slice(-2);

            if (this.financeDate == TFinanceDate.fdEra) this.cashday = payline.FinanceFlag + '-' + array[1] + '-' + array[2];
            if (this.financeDate == TFinanceDate.fdAno) this.cashday = array[0] + '-' + zeros + '-' + array[2];
            if (this.financeDate == TFinanceDate.fdMes) this.cashday = array[0] + '-' + array[1] + '-' + zeros;

            if (this.financeDate == TFinanceDate.fdMes) this.backupeDate = TFinanceDate.fdDia;
            if (this.financeDate == TFinanceDate.fdAno) this.backupeDate = TFinanceDate.fdMes;
            if (this.financeDate == TFinanceDate.fdEra) this.backupeDate = TFinanceDate.fdAno;

            this.hotviewDate('done');
            return;
        }

        if (this.etapa == 2 && finance.FinanceNome == 'Depositário') {
            this.navCtrl.push(RepasseMenuPage, {hotspotID: this.rootspot.Hotspots[0].HotspotID, gateweyID: payline.FinanceFlag});
            return;
        }

        if (this.etapa == 1 && finance.FinanceNome == 'Blend') {
            let object = {etapa: 9, perfil: this.perfil, userset: this.userset, copyspot: this.copyspot, rootspot: this.rootspot, rootcash: this.rootcash, financeSide: this.financeSide, cashday: this.cashday, financeDate: this.financeDate, financeView: this.financeView};
            this.navCtrl.push(FinanceMenuPage, object);
            return;
        }

        let indexGR = this.rootcash.Finances.indexOf(finance);
        let indexLN = this.rootcash.Finances[indexGR].FinanceLines.indexOf(payline);
        let object = {etapa: 9, perfil: this.perfil, userset: this.userset, copyspot: this.copyspot, rootspot: this.rootspot, rootcash: this.rootcash, financeSide: this.financeSide, cashday: this.cashday, financeDate: this.financeDate, financeView: this.financeView, indexGR: indexGR, indexLN: indexLN};
        this.util.modalopen(FinanceMenuPage, 'full', true, object).subscribe();

    }

    hotviewOlho(flug: null | 'icon'): string {

        if (flug == 'icon') {

            if (this.financeView == TFinanceView.ceCash) return 'b-icon-dollar';
            if (this.financeView == TFinanceView.ceCent) return 'b-icon-percent';
            if (this.financeView == TFinanceView.ceQtde) return 'b-icon-box';

        }

        if (flug == null) {

            let onView = (view : TFinanceView) => {
                this.financeView = view;
                this.storageService.set('FINANCE-VIEW', this.financeView).subscribe();
            }

            /** OPEN **/
            let buttons: Array<any> = [];
            if (this.userset.FlagOlho)
            buttons.push({text: 'R$',  handler: () => onView(TFinanceView.ceCash)});
            buttons.push({text: '%',   handler: () => onView(TFinanceView.ceCent)});
            buttons.push({text: 'Qtd', handler: () => onView(TFinanceView.ceQtde)});
            this.util.sheetOpen(buttons, 'VIEW');

        }

    }

    hotviewTint(flug: 'icon' | 'font' | 'back' | 'bord') {

        if (flug == 'icon') {
            if (this.etapa == 0) return 'b-icon-user';
            if (this.etapa == 1) return 'b-icon-flash';
            if (this.etapa == 2) return 'b-icon-dollar';
            if (this.etapa == 3) return 'b-icon-handshake-o';
        }

        if (flug == 'font') {
            if (this.financeSide == TFinanceSide.cdDebito)  return 'CorMilk';
            if (this.financeSide == TFinanceSide.cdCredito) return 'CorMilk';
            if (this.financeSide == TFinanceSide.cdTodos)   return 'CorDash';
        }

        if (flug == 'back') {
            if (this.financeSide == TFinanceSide.cdDebito)  return 'CorFood';
            if (this.financeSide == TFinanceSide.cdCredito) return 'CorBlue';
            if (this.financeSide == TFinanceSide.cdTodos)   return 'CorMilk';
        }

        if (flug == 'bord') {
            if (this.financeSide == TFinanceSide.cdDebito)  return this.config.colors.CorFood;
            if (this.financeSide == TFinanceSide.cdCredito) return this.config.colors.CorBlue;
            if (this.financeSide == TFinanceSide.cdTodos)   return this.config.colors.CorDash;
        }

        return '';

    }

    hotviewOpen(etapa) {

        let onLoad = (etape, index) => {
            this.etapa = etape;
            this.financeSide = index;

            this.financeLoad();
        };

        //Publico
        if (etapa == 0) {
            //onLoad(0, TFinanceSide.cdCredito);
        }

        //Consumo
        if (etapa == 0 || etapa == 1) {
            let buttons: Array<any> = [];
            buttons.push({text: 'Público', handler: () => onLoad(0, TFinanceSide.cdCredito)});
            buttons.push({text: 'Receita', handler: () => onLoad(1, TFinanceSide.cdCredito)});
            if (this.userset.UsuarioDesp) buttons.push({text: 'Despesa', handler: () => onLoad(1, TFinanceSide.cdDebito), role: 'destructive'});
            this.util.sheetOpen(buttons, 'CONSUMO');
        }

        //Financeiro
        if (etapa == 2) {
            let buttons: Array<any> = [];
            buttons.push({text: 'Recebido',  handler: () => onLoad(2, TFinanceSide.cdCredito)});
            if (this.userset.UsuarioDesp) buttons.push({text: 'Enviado',   handler: () => onLoad(2, TFinanceSide.cdDebito), role: 'destructive'});
            if (this.userset.UsuarioDesp) buttons.push({text: 'Resultado', handler: () => onLoad(2, TFinanceSide.cdTodos), cssClass: this.util.sheetClass(true, true, 'roxa') + ' shadow-lorean-lime'});
            this.util.sheetOpen(buttons, 'PAGAMENTO');
        }

        //Contrato
        if (etapa == 3) {
            let buttons: Array<any> = [];
            buttons.push({text: 'Crédito', handler: () => onLoad(3, TFinanceSide.cdCredito)});
            buttons.push({text: 'Débito',  handler: () => onLoad(3, TFinanceSide.cdDebito), role: 'destructive'});
            this.util.sheetOpen(buttons, 'CONTRATO');
        }

    }

    hotviewDate(flug: null | 'text' | 'done'): string {

        if (flug == 'done') {
            this.rootcash = null;
            this.financeDate = this.backupeDate;
            this.financeLoad();
            return null;
        }

        if (flug == 'text') {
            if (this.financeDate == TFinanceDate.fdEra) return 'Período';
            let dia: null | 'dd' = (this.financeDate == TFinanceDate.fdDia ? 'dd' : null);
            let mes: null | 'char' = (this.financeDate != TFinanceDate.fdAno ? 'char' : null);
            return this.util.dataft(this.cashday, dia, mes, 'yyyy');
        }


        if (flug == null) {

            let onDate = (financeDate) => {
                this.backupeDate = financeDate;
                if (financeDate == TFinanceDate.fdEra) this.hotviewDate('done');
                if (financeDate != TFinanceDate.fdEra) this.iondates.toArray()[financeDate].open();
            };

            /** OPEN **/
            let zito = this.logado.Profile.ProfileZito;
            let buttons: Array<any> = [];
            buttons.push({text: 'Dia', handler: () => onDate(TFinanceDate.fdDia)});
            buttons.push({text: 'Mês', handler: () => onDate(TFinanceDate.fdMes)});
            if (zito) buttons.push({text: 'Ano', handler: () => onDate(TFinanceDate.fdAno)});
            if (zito) buttons.push({text: 'Era', handler: () => onDate(TFinanceDate.fdEra)});
            this.util.sheetOpen(buttons, 'DATE');
            return null;

        }

    }

    hotviewIcon(payline: any): string {

        if (!payline.FinanceIcon) return 'NONE';

        let icon = (payline.FinanceIcon.slice(0, 6) == 'b-icon');
        return (icon ? 'ICON' : 'PATH');

    }

    hotviewTotal(index, flug: 'cash' | 'tint'): string {

        let array = this.rootcash.Finances;
        let cash = 0;

        if (index < 0)  cash = this.util.jsSum(array, [       'FinanceLines', 'FinanceCash'], 'FinanceSoma', [true]);
        if (index >= 0) cash = this.util.jsSum(array, [index, 'FinanceLines', 'FinanceCash'], 'FinanceSoma', [true]);

        if (flug == 'cash') {
            if (this.financeView != TFinanceView.ceCash) return 'R$ • • • • • •';
            return this.util.dinheiro(cash);
        }

        if (flug == 'tint') {
            if (cash == 0) return 'CorDash';
            if (cash > 0)  return 'CorBlue';
            if (cash < 0)  return 'CorFood';
        }

    }

    hotviewLeft() {

        if (this.etapa < 4) {
            let title = 'Projeto';
            let finance = this.rootcash.Finances.find(FN => FN.FinanceNome == title);

            let onLoad = (line) => {
                this.filtred = line;
                this.financeLoad();
            };

            /** OPEN **/
            let buttons: Array<any> = [];
            buttons.push({text: 'Todos', cssClass: this.util.sheetClass(), handler: () => onLoad(null)});
            if (finance) finance.FinanceLines.forEach(line => buttons.push({text: line.FinanceText, handler: () => onLoad(line)}));
            this.util.sheetOpen(buttons, title, 0);
        }

        if (this.etapa == 4) {
            let onLoad = (line) => {
                this.filtred = line;
                this.financeLoad();
            };

            /** OPEN **/
            let buttons: Array<any> = [];
            let array = this.copyspot.Accounts;
            array.forEach(AC => buttons.push({text: AC.AccountNocc, handler: () => onLoad(AC)}));
            this.util.sheetOpen(buttons, 'CONTA');
        }

    }

    resgateMenu(payline) {

        let object = {etapa: 2, hotspotID: this.copyspot.Hotspots[0].HotspotID, gatewey: this.copyspot.Hotspots[0].Gatewey, financeDate: TFinanceDate.fdDia, paymentStep: TPaymentStep.psLiquidado, paymentTest: false, cashday: payline.FinanceCode};
        this.navCtrl.push(GateweyMenuPage, object);

    }

    pulsePressed() {

        if (!this.pulsedElement) return;

        let handle;
        handle = setInterval(() => {

            let heightComp = this.pulsedElement.nativeElement.getBoundingClientRect().top;
            let heightHead = this.header.getNativeElement().clientHeight;
            let heightWind = window.innerHeight;
            this.pulsed = (heightComp > heightHead && heightComp < heightWind);

            if (this.pulsed) {
                clearInterval(handle);
                setTimeout(() => this.pulsed = false, 2000);
            }

        }, 1000);

    }

    linemore(finance: any, press: boolean) {

        finance.linecount = (finance.linecount || 12);
        finance.linecount += (!press ? 12 : finance.FinanceLines.length);
        if (press) this.util.impact();

    }




    dismiss() {

        this.navCtrl.pop();

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/finance-menu/finance-menu.ts